import { useEffect } from 'react';
import TagManager from 'react-gtm-module';

export const useCustomEvent = () => {
  const moviePlayEvent = (page_path: string) => {
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID!,
      dataLayer: { event: 'movie_play', page_path: page_path },
    });
  };

  return { moviePlayEvent };
};
